import './ErrorMessage.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { getErrorMessage } from '../../utils/errors';
import { Button } from '..';

/**
 * ErrorMessage Component
 * @augments {Component<Props, State>}
 */
class ErrorMessage extends Component {
    render() {
        const { close, error, children } = this.props;
        return (
            <div className={'ErrorMessage'}>
                <div className={'message-container'}>
                    {getErrorMessage(error).split('\n').map((line, idx) => (<p key={idx}>{line}</p>))}
                </div>
                {close && (
                    <div className={'button-container'}>
                        <Button label={'OK'} onClick={close} />
                        {children}
                    </div>
                )}
            </div>
        );
    }
}

ErrorMessage.defaultProps = {
    close: null
};

ErrorMessage.propTypes = {
    children: PropTypes.node,
    error: PropTypes.shape().isRequired,
    close: PropTypes.func,
};


export default ErrorMessage;